export const getInitials = str =>
  str
    .split(' ')
    .map(splitStr => splitStr.trim())
    .filter(splitStr => Boolean(splitStr))
    .filter((_, i) => i < 2)
    .map(splitStr => splitStr.charAt(0))
    .join('')
    .toUpperCase();
